











































import Vue from 'vue';
import SynaMemberDocumentRequestResourceViewModel from '@/src/services/viewModel/resource/SynaMemberDocumentRequestResourceViewModel';
import { downloadZip } from 'client-zip';

export default Vue.extend({
  layout: 'layout-guest',
  auth: false,
  data: () => ({
    isDownloading: false,
    shareDocuments: new SynaMemberDocumentRequestResourceViewModel().fromModel({}),
    errorResponse: undefined as any,
    isLoading: false,
    documents: [],
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
    shareId() {
      return this.$route.params.shareId;
    },
    columns(): any {
      return [
        { value: this.$t('page.documentShareId.table.id'), field: 'id', width: '30px' },
        { value: this.$t('page.documentShareId.table.fileName'), field: 'originalFileName', textAlign: 'left' },
        { value: this.$t('page.documentShareId.table.contentType'), field: 'contentType', textAlign: 'left' },
        { value: this.$t('page.documentShareId.table.contentLength'), field: 'contentLength', textAlign: 'left', format: (size: string) => this.$format.bytesPretty(size) },
      ];
    },
  },
  methods: {
    async populateDocumentListByShareId() {
      this.shareDocuments = await this.$service.api.memberDocuments.getMemberDocumentsByShareId(this.shareId);
      return this.shareDocuments.documents;
    },
    async downloadAllFiles(){
      this.isDownloading = true;
      try{
        const allPromises = [] as Promise<any>[];
        this.documents.forEach((document: any) => {
          const documentId = document?.id?.value ?? document.id;
          const promise = this.$service.api.memberDocuments.downloadSharedDocument(this.shareId, documentId);
          allPromises.push(new Promise((resolve) => {
            promise.then(response => {
              const documentName = `${this.$date.now().format('YYYY-MM-DD')} - Syna Portal Download ${document.id}${document.fileExtension}`;
              resolve({response, documentName})
            })
          }));
        });
        const downloadedDocs = await Promise.all(allPromises);
        const mappedDocs = downloadedDocs.map((doc, index) => ({ name: doc.documentName, lastModified: new Date(), input: doc.response }))
        const zipBlob = await downloadZip(mappedDocs).blob();
        const documentName = `${this.$date.now().format('YYYY-MM-DD')} - Syna Portal Download.zip`;
        this.$service.utils.downloadFile(documentName, zipBlob as any);
      } catch(error: any){
        this.errorResponse = error;
      }
      this.isDownloading = false;
    },
    async downloadFile(entry : any) {
      this.isDownloading = true;
      try{
        const documentId = entry?.id?.value ?? entry.id;
        const documentName = `${this.$date.now().format('YYYY-MM-DD')} - Syna Portal Download ${entry.id.value}${entry.fileExtension.value}`;
        const blob = await this.$service.api.memberDocuments.downloadSharedDocument(this.shareId, documentId);
        this.$service.utils.downloadFile(documentName, blob);
      }catch(error: any){
        this.errorResponse = error;
      }
      this.isDownloading = false;
    },
  },
});
